import { TenantConfig } from "../tenant.model";

export const tenant: TenantConfig = {
    tenandId: 'lumsa',
    brandName: 'Lumìa',
    brandLogoImage: null,
    favicon: 'lumsa-favicon.ico',
    showSupplierLogo: false,
    apiUrl: 'https://api.lumsa.test.assistant.beta80group.it',
    apiUrlProd: 'https://api.lumsa.assistant.beta80group.it',
    navigationItems: [
        { label: 'Home', route: '/overview', group: 'settings' },
        { label: 'Statistiche', route: '/statistiche', group: 'navigation', featureName: 'statistics' },
        { label: 'Documenti', route: '/documenti', group: 'navigation', featureName: 'document' },
        { label: 'Links', route: '/ingestion-link', group: 'navigation', featureName: 'ingestion-link' },
        { label: 'Conversazioni', route: '/conversazioni', group: 'navigation', featureName: 'conversations' },
        { label: 'Valutazioni', route: '/valutazioni', group: 'navigation', featureName: 'feedback' },
        { label: 'Ricerca Chunks', route: '/chunks', group: 'navigation', featureName: 'chunk' },
        { label: 'Permessi', route: '/permessi', group: 'navigation', featureName: 'permissions', requiresAdmin: true },
        { label: 'Impostazioni', route: '/impostazioni', group: 'navigation', featureName: 'settings', requiresAdmin: true },
    ],
    apiEndpoints: {
        document: '/document',
        assistant: '/assistant',
    },
    documentiApi: '/document',
    documentCategories: [],
    samlProviderName: 'assistant-external-idp',
    samlProviderNameProd: 'assistant-external-idp-lumsa',
    samlEnabled: true,
    chatConfig: {
        useRemoteLoader: true,
        remoteTestUrl: 'https://d3so8u9uewocbp.cloudfront.net/bundle/lumia-chat.bundle.js',
        remoteProdUrl: 'https://d11zdqjy12f21w.cloudfront.net/bundle/lumia-chat.bundle.js',
        bundleFile: 'lumia-chat.bundle.js',
        elementTag: 'lumia-chat',
        assistantName: 'LUMSA',
        envConfig: {
            uat: { apiEndpoint: 'https://api.lumsa.test.assistant.beta80group.it' },
            prod: { apiEndpoint: 'https://api.lumsa.assistant.beta80group.it' },
        },
    },
    amplifyConfig: {
        // --- TEST (same Cognito pool, test domain redirects) ---
        samlAuth: {
            region: 'eu-central-1',
            userPoolId: 'eu-central-1_qlOdffouZ',
            userPoolWebClientId: '25jfn5r7rq5u5937h66e7b10g3',
            mandatorySignIn: false,
            authenticationFlowType: 'USER_SRP_AUTH',
            customCinecaLogoutUrl: 'https://lumsa.idp.pp.cineca.it/idp/profile/Logout',
            oauth: {
                domain: 'eu-central-1qlodffouz.auth.eu-central-1.amazoncognito.com',
                scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'profile'],
                redirectSignIn: 'https://www.lumsa.test.assistant.beta80group.it/',
                redirectSignOut: 'https://www.lumsa.test.assistant.beta80group.it/logout-handler',
                responseType: 'code',
            },
        },
        nativeAuth: {
            region: 'eu-central-1',
            userPoolId: 'eu-central-1_qlOdffouZ',
            userPoolWebClientId: '3drj9ovogdkruospvtckscg0bt',
            mandatorySignIn: false,
            authenticationFlowType: 'USER_PASSWORD_AUTH',
            oauth: {
                domain: 'eu-central-1qlodffouz.auth.eu-central-1.amazoncognito.com',
                scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'profile'],
                redirectSignIn: 'https://www.lumsa.test.assistant.beta80group.it/',
                redirectSignOut: 'https://www.lumsa.test.assistant.beta80group.it/login-admin',
                responseType: 'code',
            },
        },
        // --- PROD (different Cognito pool, production domain redirects) ---
        samlAuthProd: {
            region: 'eu-central-1',
            userPoolId: 'eu-central-1_0tuzUdD69',
            userPoolWebClientId: '4vuu0j367rb4nq9e0v0jh601k7',
            mandatorySignIn: false,
            authenticationFlowType: 'USER_SRP_AUTH',
            customCinecaLogoutUrl: 'https://idp.lumsa.it/idp/profile/Logout',
            oauth: {
                domain: 'eu-central-10tuzudd69.auth.eu-central-1.amazoncognito.com',
                scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'profile'],
                redirectSignIn: 'https://www.console.lumsa.assistant.beta80group.it/',
                redirectSignOut: 'https://www.console.lumsa.assistant.beta80group.it/logout-handler',
                responseType: 'code',
            },
        },
        nativeAuthProd: {
            region: 'eu-central-1',
            userPoolId: 'eu-central-1_0tuzUdD69',
            userPoolWebClientId: '6j8jmr3al82ke7c0ls7infau3d',
            mandatorySignIn: false,
            authenticationFlowType: 'USER_PASSWORD_AUTH',
            oauth: {
                domain: 'eu-central-10tuzudd69.auth.eu-central-1.amazoncognito.com',
                scope: ['aws.cognito.signin.user.admin', 'email', 'openid', 'profile'],
                redirectSignIn: 'https://www.console.lumsa.assistant.beta80group.it/',
                redirectSignOut: 'https://www.console.lumsa.assistant.beta80group.it/',
                responseType: 'code',
            },
        },
    },
    theme: {
        semantic: {
            primary: {
                50: '#e0f2ec',
                100: '#b3dfcf',
                200: '#80cbb0',
                300: '#4db791',
                400: '#26a77a',
                500: '#0B7749',
                600: '#096840',
                700: '#075a36',
                800: '#054b2d',
                900: '#033d23',
                950: '#022e1a',
            },
            danger: {
                50: '#fef2f2',
                100: '#fee2e2',
                200: '#fecaca',
                300: '#fca5a5',
                400: '#f87171',
                500: '#74262B',
                600: '#5e1e22',
                700: '#4a181c',
                800: '#371215',
                900: '#240c0e',
                950: '#180809',
            },
            secondary: {
                50: '#f5f5f5',
                100: '#e5e5e5',
                200: '#cccccc',
                300: '#b3b3b3',
                400: '#999999',
                500: '#555555',
                600: '#444444',
                700: '#333333',
                800: '#222222',
                900: '#111111',
                950: '#0a0a0a',
            },
            formField: {
                borderRadius: '4px',
                paddingX: '12px',
                paddingY: '12px',
                borderWidth: '2px',
            },
        },
        form: {
            iconColor: '#0B7749',
        },
        components: {
            datatable: {
                headerCell: {
                    background: '#e0f2ec',
                }
            },
            card: {
                body: {
                    padding: '0',
                }
            },
            dialog: {
                header: {
                    padding: '32px 32px 0 32px',
                },
                content: {
                    padding: '32px',
                },
                footer: {
                    padding: '0 32px 32px 32px',
                }
            },
        }
    },
};
